export default "__VITE_ASSET__BiSDH_NR__"